import React, { useState, useEffect, useContext } from 'react';
import { useIntl } from 'react-intl';
import { Layout } from '../../contexts/LayoutContext';
import Header from './sections/Header';
import Quote from './sections/Quote';
import Actions from './sections/Actions';
import Simulation from './sections/Simulation';
import Relax from './sections/Relax';
import MoreActions from './sections/MoreActions';
import PromoCodeContext from '../../contexts/PromoCodeContext';
import sanitizePlans from '../CreateAccount/sanitizePlans';

const LandingInstagram = () => {
  const intl = useIntl();
  const { PromoCode } = useContext(PromoCodeContext);
  const [trialDaysM, setTrialDaysM] = useState(0);

  useEffect(() => {
    const [monthlyPlan] = sanitizePlans(PromoCode);
    setTrialDaysM(monthlyPlan.trialDuration);
  }, [PromoCode]);

  return (
    <Layout
      title={intl.formatMessage({
        id: 'k.seo.title',
        defaultMessage: '{titlePage} Schedule and manage your business social media.',
      }, {
        titlePage: 'Instagram',
      })}
    >
      <Header daysTrial={trialDaysM} />
      <Quote />
      <Actions />
      <Simulation />
      <Relax daysTrial={trialDaysM} />
      <MoreActions daysTrial={trialDaysM} />
    </Layout>
  );
};

export default LandingInstagram;
